import { Titlebar as CloudTitlebar } from '@itential/cloud-portal-titlebar';
import { useAuthenticatedCloudUser } from '@itential/cloud-auth-client';
import { JSXElement } from '@/common/types';
import { env } from '@/utils/shared/env';

export const Titlebar = (): JSXElement => {
    const { realm, hubToken, signOut } = useAuthenticatedCloudUser();

    return (
        <CloudTitlebar
            showHamburgerMenu
            title={realm}
            trainingUrl={env.VITE_TRAINING_URL}
            hubToken={hubToken}
            onLogout={() => signOut()}
        />
    );
};
